/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Ai_Chat_Steps_CollapseInputs */

const en_admin_ai_chat_steps_collapse = /** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Collapse ${i?.count} earlier steps`)
};

const de_admin_ai_chat_steps_collapse = /** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} frühere Schritte einklappen`)
};

const es_admin_ai_chat_steps_collapse = /** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ocultar ${i?.count} pasos anteriores`)
};

const fr_admin_ai_chat_steps_collapse = /** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Réduire ${i?.count} étapes précédentes`)
};

const nl_admin_ai_chat_steps_collapse = /** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} eerdere stappen samenvouwen`)
};

/** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */
const it_admin_ai_chat_steps_collapse = en_admin_ai_chat_steps_collapse;

/** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_steps_collapse = en_admin_ai_chat_steps_collapse;

/** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */
const pl_admin_ai_chat_steps_collapse = en_admin_ai_chat_steps_collapse;

/** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */
const hu_admin_ai_chat_steps_collapse = en_admin_ai_chat_steps_collapse;

/** @type {(inputs: Admin_Ai_Chat_Steps_CollapseInputs) => LocalizedString} */
const ro_admin_ai_chat_steps_collapse = en_admin_ai_chat_steps_collapse;

/**
* | output |
* | --- |
* | "Collapse {count} earlier steps" |
*
* @param {Admin_Ai_Chat_Steps_CollapseInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_steps_collapse = /** @type {((inputs: Admin_Ai_Chat_Steps_CollapseInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Steps_CollapseInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_steps_collapse(inputs)
	if (locale === "de") return de_admin_ai_chat_steps_collapse(inputs)
	if (locale === "es") return es_admin_ai_chat_steps_collapse(inputs)
	if (locale === "fr") return fr_admin_ai_chat_steps_collapse(inputs)
	if (locale === "nl") return nl_admin_ai_chat_steps_collapse(inputs)
	if (locale === "it") return it_admin_ai_chat_steps_collapse(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_steps_collapse(inputs)
	if (locale === "pl") return pl_admin_ai_chat_steps_collapse(inputs)
	if (locale === "hu") return hu_admin_ai_chat_steps_collapse(inputs)
	return ro_admin_ai_chat_steps_collapse(inputs)
});
export { admin_ai_chat_steps_collapse as "admin.ai_chat.steps_collapse" }